function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.8616 5.61292H2.86157",
  stroke: "#465063",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.86133 1L2 5.65186L5.86133 10",
  stroke: "#465063",
  strokeWidth: 2,
  strokeLinecap: "round"
});
const SvgBackIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 11,
  viewBox: "0 0 16 11",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back_icon.e4a06935.svg";
export { ForwardRef as ReactComponent };